import { getModelParams } from '../../common/model/utils';
import isVehicleShopperEnabled from '../../common/isVehicleShopperEnabled';
import {
  getDefaultLinks,
  getEmptyIfContainLocalhost
} from './shoppingHelper.constant';
import _ from 'lodash';

const SCHEDULE_TEST_DRIVE = 'schedule.test.drive';

const processOldShoppingLinksResponse = (response, defaultLinks, baseUrl) => {
  const quantumLinks = _.reduce(
    response,
    function(hash, value) {
      _.each(value, function(v, k) {
        let template = baseUrl + v;
        const key = k === 'rtd' ? SCHEDULE_TEST_DRIVE : k;

        if (key !== 'modelselector' && key !== 'sitemap') {
          if (defaultLinks[key]) {
            var index = defaultLinks[key].indexOf('?');
            if (index > -1) {
              template += defaultLinks[key].substring(index);
            }
          }
        }

        hash[key] = template;
      });
      return hash;
    },
    {}
  );

  return _.extend(defaultLinks, quantumLinks);
};

const buildLinks = (links, defaultLinks, baseUrl) => {
  if (Array.isArray(links)) {
    return processOldShoppingLinksResponse(links, defaultLinks, baseUrl);
  } else {
    _.each(links, function(value, key) {
      let template = baseUrl + value;
      const finalKey = key === 'rtd' ? SCHEDULE_TEST_DRIVE : key;

      if (finalKey === 'lnv' && isVehicleShopperEnabled(value)) {
        links[finalKey] = value;
      } else {
        if (finalKey !== 'modelselector' && finalKey !== 'sitemap') {
          if (defaultLinks[finalKey]) {
            const index = defaultLinks[finalKey].indexOf('?');
            if (index > -1) {
              template += defaultLinks[finalKey].substring(index);
            }
          }
        }
        links[finalKey] = template;
      }
    });

    return _.extend(defaultLinks, links);
  }
};

export default function normalizeShoppingLinks(data, state) {
  const params = getModelParams();
  const { carline, modelyear, bodystyle } = params;
  const defaultLinks = getDefaultLinks(state.appResources, state.deviceType);
  const baseUrl = getEmptyIfContainLocalhost(state.appResources.urls.baseUrl);

  const links = _.has(data, 'ShoppingLinks')
    ? _.get(data, 'ShoppingLinks')
    : _.get(data, `${modelyear}.${carline}.${bodystyle}`);

  return buildLinks(links, defaultLinks, baseUrl);
}
